import React from "react";
import { CtaButton } from "./CtaButton";
export function SiteHeader() {
  return <header className="sticky top-0 z-30 border-b border-line bg-ink/90 backdrop-blur" data-id="element-236" data-mp="19vrk56awt0pi">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-6" data-id="element-237" data-mp="1nmwoglp82h66">
        <a href="#top" className="font-display text-xl font-black tracking-tight" data-id="element-238" data-mp="1intk73h2gez9">
          CLARIFY<span className="text-accent" data-id="element-239" data-mp="1iq5zf8vfwb8m">.</span>
        </a>
        <CtaButton label="Unirme" size="md" data-id="element-240" data-mp="uz0jktpi1iyb" />
      </div>
    </header>;
}